import { InstantQuoteContext } from '@containers/Apparel/InstantQuote/Stepper/context';
import { theme } from '@lib/style/theme';
import { unitStrict } from '@lib/style/unit';
import Tab from '@material-ui/core/Tab/Tab';
import Tabs, { TabsProps } from '@material-ui/core/Tabs/Tabs';
import { PAGE_HEADER_THEME } from '@packages/layout/lib/PageHeader/theme';
import { applyRef } from '@packages/react/applyRef';
import React, { forwardRef, useContext } from 'react';
import styled from 'styled-components';

const HEADER_MOBILE_HEIGHT = unitStrict(PAGE_HEADER_THEME.get('size.mobile'));

const StyledTabs = styled(Tabs)`
    && {
        height: ${HEADER_MOBILE_HEIGHT};
        background: ${PAGE_HEADER_THEME.get('background')};
        align-content: center;
        align-items: center;
        justify-content: center;
        width: 100%;
        .iq-navigation__tab {
            height: ${HEADER_MOBILE_HEIGHT};
            color: #eee;
            transition: background-color 200ms;
            opacity: 1;
            @media screen and (max-width: 959px) {
                padding-left: 14px;
                padding-right: 14px;
            }
            &:disabled {
                opacity: 0.6;
            }
            &:after {
                content: ' ';
                position: absolute;
                left: 50%;
                bottom: -20px;
                margin-left: -10px;
                width: 20px;
                height: 20px;
                background-color: #eee;
                z-index: 9;
                transform: rotate(45deg);
                opacity: 0;
                transition: opacity 200ms;
            }

            &:hover,
            &__selected {
                position: relative;
                background-color: ${theme('colors.primary')};
                color: #fff;
                transition: background-color 200ms;

                &:after {
                    opacity: 1;
                    bottom: -10px;
                    transition: all 200ms;
                }
            }

            &__holder {
                align-content: center;
                align-items: center;
                justify-content: center;
            }
        }

        @media screen and (max-width: 959px) {
            height: ${HEADER_MOBILE_HEIGHT};
            .iq-navigation__tab {
                height: ${HEADER_MOBILE_HEIGHT};
                &__holder {
                    justify-content: start;
                }
            }
        }
    }
`;

interface IQNavigationProps extends Omit<TabsProps, 'value'> {
    tabs: any[];
    onChange?: any;
    active: number;
}

/**
 *
 * @param props
 * @returns {null|*}
 * @constructor
 */
const IQNavigation = forwardRef<any, IQNavigationProps>((props, ref) => {
    const { active, onChange, tabs, ...rest } = props;
    const { instantQuote } = useContext(InstantQuoteContext);

    const tabClasses = {
        root: 'iq-navigation__tab',
        selected: 'iq-navigation__tab__selected',
    };

    applyRef(rest, ref);

    // noinspection TypeScriptValidateJSTypes
    return (
        <StyledTabs
            value={active}
            onChange={onChange}
            indicatorColor={'primary'}
            textColor={'primary'}
            variant={'scrollable'}
            classes={{ flexContainer: 'iq-navigation__tab__holder' }}
            {...rest}
        >
            {tabs.map((tab: any) => (
                <Tab
                    key={tab.idx}
                    label={tab.label}
                    classes={tabClasses}
                    disabled={tab.valid && typeof tab.valid === 'function' && !tab.valid(instantQuote)}
                />
            ))}
        </StyledTabs>
    );
});

export default IQNavigation;
